"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Head = void 0;
var _head = _interopRequireDefault(require("next/head"));
var _CustomMetadataHead = require("./CustomMetadataHead");
var _SharingHead = require("./SharingHead");
var _jsxRuntime = require("react/jsx-runtime");
const Head = ({
  pageMetaData,
  environment
}) => {
  if (!pageMetaData) {
    return null;
  }
  const follow = pageMetaData.robots?.follow && environment === 'live' ? 'follow' : 'nofollow';
  const index = pageMetaData.robots?.index && environment === 'live' ? 'index' : 'noindex';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_head.default, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, shrink-to-fit=no"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "robots",
        content: `${follow},${index}`
      }), (pageMetaData.browserTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
        children: pageMetaData.browserTitle
      })) ?? '', (pageMetaData.searchTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "searchTitle",
        content: pageMetaData.searchTitle
      })) ?? '', (pageMetaData.category && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "category",
        content: pageMetaData.category
      })) ?? '', (pageMetaData.section && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "section",
        content: pageMetaData.section
      })) ?? '', (pageMetaData.visibility && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "visibility",
        content: pageMetaData.visibility
      })) ?? '', (pageMetaData.segment && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "segment",
        content: pageMetaData.segment
      })) ?? '', (pageMetaData.spo && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "spo",
        content: pageMetaData.spo
      })) ?? '']
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SharingHead.SharingHead, {
      url: pageMetaData.sharingUrl,
      pageMetaImage: pageMetaData.sharingThumbnail,
      description: pageMetaData.sharingDescription,
      title: pageMetaData.browserTitle,
      iosBanner: pageMetaData.iosSmartAppBanner,
      androidBanner: pageMetaData.androidSmartAppBanner
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomMetadataHead.CustomMetadataHead, {
      customMetaData: pageMetaData.customMetaData
    })]
  });
};
exports.Head = Head;
